'use strict';
'use es6';

/**
 * @param {function} func
 * @returns A function that returns the last result if given the same arg, `func(...args)` otherwise
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
var memoizeLastResult = exports.memoizeLastResult = function memoizeLastResult(func) {
  var hasBeenCalled = false;
  var lastArgs = void 0;
  var lastResult = void 0;

  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (!hasBeenCalled || args.some(function (arg, i) {
      return arg !== lastArgs[i];
    })) {
      hasBeenCalled = true;
      lastArgs = args;
      lastResult = func.apply(undefined, args);
    }
    return lastResult;
  };
};